var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "0 0 100 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0L100 40V106C100 113.732 93.732 120 86 120H14C6.26801 120 0 113.732 0 106V14C0 6.26801 6.26801 0 14 0H60Z",
    fill: "url(#paint0_linear_0_116)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0L100 40V106C100 113.732 93.732 120 86 120H14C6.26801 120 0 113.732 0 106V14C0 6.26801 6.26801 0 14 0H60Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_116)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 40H74.7071C66.9751 40 60 33.0249 60 25.2929V0L100 40Z",
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9437 51.3333H50.6771C52.9437 51.3333 54.6771 53.0667 54.5437 55.3333V83.3333C54.5437 84.6667 54.0104 85.7333 52.9437 86.5333C52.8104 86.6667 52.6771 86.6667 52.5437 86.6667C52.4771 86.6667 52.4437 86.6333 52.4104 86.6C52.3771 86.5667 52.3437 86.5333 52.2771 86.5333C52.0104 86.5333 51.8771 86.2667 51.8771 86V80C51.8771 77.8667 50.5437 75.8667 48.4104 75.0667L47.7437 74.6667C47.7437 74.6667 47.6104 74.5333 47.4771 74.5333C47.4456 74.5019 47.4067 74.4704 47.3656 74.4371C47.2327 74.3296 47.0771 74.2037 47.0771 74L46.6771 71.3333V54C46.6771 53.4667 46.5437 52.8 46.2771 52.2667C46.2771 52 46.2771 51.7333 46.4104 51.6C46.5437 51.4667 46.6771 51.3333 46.9437 51.3333ZM32.1437 60L33.8771 54H34.1437L35.8771 60C36.0104 60.5333 35.8771 61.2 35.4771 61.6C34.9437 62.1333 32.9437 62.1333 32.4104 61.6C32.0104 61.2 31.8771 60.5333 32.1437 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6771 53.2C32.8105 52.8 33.0771 52.6667 33.3438 52.6667H34.6771C34.9438 52.6667 35.2105 52.8 35.3438 53.2L36.1438 56.2667L37.2105 54L35.6105 50.2667V50H32.0105V50.2667L30.6771 54L31.7438 56.5333L32.6771 53.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.077 75.8667L48.0104 76.2667C49.6104 76.8 50.677 78.2667 50.677 80V86C50.677 88.2667 48.9437 90 46.677 90H24.0104C21.7437 90 20.0104 88.2667 20.0104 86V54C20.0104 51.7333 21.7437 50 24.0104 50H30.677L29.3437 53.7333V54.2667L30.677 57.6C30.8104 57.8667 31.077 58 31.3437 58L30.8104 59.6C30.4104 60.5333 30.677 61.7333 31.477 62.5333C32.0104 63.0667 32.9437 63.3333 34.0104 63.3333C35.077 63.3333 36.0104 63.0667 36.5437 62.5333C37.3437 61.7333 37.6104 60.5333 37.2104 59.6L36.677 57.8667C36.8104 57.8667 36.9437 57.7333 36.9437 57.6L38.677 54.2667C38.8104 54.1333 38.8104 53.8667 38.677 53.7333L36.9437 50H41.2104C43.477 50 45.2104 51.7333 45.2104 54V73.3333C45.2104 74.5333 46.0104 75.4667 47.077 75.8667ZM31.3437 84.6667H32.677C33.077 84.6667 33.3437 84.4 33.3437 84C33.3437 83.6 33.077 83.3333 32.677 83.3333H31.3437C30.9437 83.3333 30.677 83.6 30.677 84C30.677 84.4 30.9437 84.6667 31.3437 84.6667ZM32.677 82H31.3437C30.9437 82 30.677 81.7333 30.677 81.3333C30.677 80.9333 30.9437 80.6667 31.3437 80.6667H32.677C33.077 80.6667 33.3437 80.9333 33.3437 81.3333C33.3437 81.7333 33.077 82 32.677 82ZM31.3437 79.3333H32.677C33.077 79.3333 33.3437 79.0667 33.3437 78.6667C33.3437 78.2667 33.077 78 32.677 78H31.3437C30.9437 78 30.677 78.2667 30.677 78.6667C30.677 79.0667 30.9437 79.3333 31.3437 79.3333ZM32.677 76.6667H31.3437C30.9437 76.6667 30.677 76.4 30.677 76C30.677 75.6 30.9437 75.3333 31.3437 75.3333H32.677C33.077 75.3333 33.3437 75.6 33.3437 76C33.3437 76.4 33.077 76.6667 32.677 76.6667ZM31.3437 74H32.677C33.077 74 33.3437 73.7333 33.3437 73.3333C33.3437 72.9333 33.077 72.6667 32.677 72.6667H31.3437C30.9437 72.6667 30.677 72.9333 30.677 73.3333C30.677 73.7333 30.9437 74 31.3437 74ZM32.677 71.3333H31.3437C30.9437 71.3333 30.677 71.0667 30.677 70.6667C30.677 70.2667 30.9437 70 31.3437 70H32.677C33.077 70 33.3437 70.2667 33.3437 70.6667C33.3437 71.0667 33.077 71.3333 32.677 71.3333ZM31.3437 68.6667H32.677C33.077 68.6667 33.3437 68.4 33.3437 68C33.3437 67.6 33.077 67.3333 32.677 67.3333H31.3437C30.9437 67.3333 30.677 67.6 30.677 68C30.677 68.4 30.9437 68.6667 31.3437 68.6667ZM32.677 66H31.3437C30.9437 66 30.677 65.7333 30.677 65.3333C30.677 64.9333 30.9437 64.6667 31.3437 64.6667H32.677C33.077 64.6667 33.3437 64.9333 33.3437 65.3333C33.3437 65.7333 33.077 66 32.677 66ZM35.3437 83.3333H36.677C37.077 83.3333 37.3437 83.0667 37.3437 82.6667C37.3437 82.2667 37.077 82 36.677 82H35.3437C34.9437 82 34.677 82.2667 34.677 82.6667C34.677 83.0667 34.9437 83.3333 35.3437 83.3333ZM36.677 80.6667H35.3437C34.9437 80.6667 34.677 80.4 34.677 80C34.677 79.6 34.9437 79.3333 35.3437 79.3333H36.677C37.077 79.3333 37.3437 79.6 37.3437 80C37.3437 80.4 37.077 80.6667 36.677 80.6667ZM35.3437 78H36.677C37.077 78 37.3437 77.7333 37.3437 77.3333C37.3437 76.9333 37.077 76.6667 36.677 76.6667H35.3437C34.9437 76.6667 34.677 76.9333 34.677 77.3333C34.677 77.7333 34.9437 78 35.3437 78ZM36.677 75.3333H35.3437C34.9437 75.3333 34.677 75.0667 34.677 74.6667C34.677 74.2667 34.9437 74 35.3437 74H36.677C37.077 74 37.3437 74.2667 37.3437 74.6667C37.3437 75.0667 37.077 75.3333 36.677 75.3333ZM35.3437 72.6667H36.677C37.077 72.6667 37.3437 72.4 37.3437 72C37.3437 71.6 37.077 71.3333 36.677 71.3333H35.3437C34.9437 71.3333 34.677 71.6 34.677 72C34.677 72.4 34.9437 72.6667 35.3437 72.6667ZM36.677 70H35.3437C34.9437 70 34.677 69.7333 34.677 69.3333C34.677 68.9333 34.9437 68.6667 35.3437 68.6667H36.677C37.077 68.6667 37.3437 68.9333 37.3437 69.3333C37.3437 69.7333 37.077 70 36.677 70ZM35.3437 67.3333H36.677C37.077 67.3333 37.3437 67.0667 37.3437 66.6667C37.3437 66.2667 37.077 66 36.677 66H35.3437C34.9437 66 34.677 66.2667 34.677 66.6667C34.677 67.0667 34.9437 67.3333 35.3437 67.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_116",
    x: 58,
    y: -4,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_116",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC3CD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesZip);
export default __webpack_public_path__ + "static/media/files-zip.e13b745e851eabfb64852d87624ed0f8.svg";
export { ForwardRef as ReactComponent };